export const projects = [
	{
		img: 'https://miro.medium.com/max/1400/1*tds0Sy4f9sFynFElZV5DnA.jpeg',
		title: 'Nike clone',
		des: "A web application to buy sports and fashion accessories along with the suitable clothes.",
		demo: '',
		live: 'https://nike-five.vercel.app/',
		gitHub: 'https://github.com/salakhas/Nike',
		technologies: [  'JavaScript',"HTML" ,'CSS'],
	},
	{
		img: 'https://miro.medium.com/max/875/1*-00AnT5GSpNQjnmfBquWQw.png',
		title: 'YesStyle clone',
		des: 'Myglamm is a fashion product website which deals in each and every type of product & its collection.This website has features such as users can buy product,select the product,checkout.',
		demo: '',
		live: 'https://yesstyle-unit-3-project2-n8y35dknk-jatinsharma9871.vercel.app/',
		gitHub: 'https://github.com/jatinsharma9871/yesstyle-unit-3-project',
		technologies: ['JavaScript',"HTML" ,'CSS'],
	},
	{
		img: 'https://miro.medium.com/max/875/1*54tc54lVhhApYqCbJH7qTg.png',
		title: 'Clone of YesStyle',
		des: 'This is a clone of a Japnise-based e-commerce website for fashion accessories products. Which sells clothes and accessories. ',
		demo: '',
		live: 'https://yesstyle-web-app.herokuapp.com/',
		gitHub: 'https://github.com/RoshanIndane/Unit4_YesstyleClone',
		technologies: ['Express', 'MongoDb', 'nodeJS', 'Ejs', "Bootstrap"],
	},
	// {
		// 	img: 'https://camo.githubusercontent.com/b7f4aa8c34ddf776dd19b78dc3488456470a73e5026f48784e9e753601468802/68747470733a2f2f6d656469612e67697068792e636f6d2f6d656469612f4c62507030307771454537386c6f68584d372f67697068792e676966',
		// 	title: 'Clone of Fitness Blender',
		// 	des: 'This is a clone of the Fitness Blender website. The clone is complete with a Login page, Sign-in page, Shopping Cart, Wishlist and Calendar Scheduling feature. Following is the link to the clone of the website.',
		// 	demo: '',
		// 	live: 'https://anshusagar.github.io/FitnessBlender/',
		// 	gitHub: 'https://github.com/Anshusagar/FitnessBlender.git',
		// 	technologies: ['HTML', 'CSS', 'javaScript'],
		// },
		// {
			// 	img: 'https://github.com/mandarsatam/Mailchimp-Clone/blob/master/Snips/Screenshot%20(79).png?raw=true',
			// 	title: 'Mailchimp Clone',
			// 	des: 'This is a static clone of a website called Mailchimp. This clone includes landing, pricing, our story, and the resources page.',
			// 	demo: '',
			// 	live: 'https://mandarsatam.github.io/Mailchimp-Clone/',
	// 	gitHub: 'https://github.com/mandarsatam/Mailchimp-Clone',
	// 	technologies: ['HTML', 'CSS', 'javaScript'],
	// },
	// {
	// 	img: 'https://user-images.githubusercontent.com/86410106/143928012-c66d0c3c-1f94-4894-b1f0-2326be4f3087.png',
	// 	title: 'Clone of Target.com ',
	// 	des: 'This is a clone of a US-based e-commerce website for all products built with HTML, CSS, JS. Have features that allow users to sort the product on the basis of price, on the payment page users can apply promo codes',
	// 	demo: '',
	// 	live: 'https://pandeypushpendra3.github.io/target/', // deployed link
	// 	gitHub: 'https://github.com/pandeypushpendra3/target/tree/main',
	// 	technologies: [ 'HTML', 'CSS', 'javaScript'],
	// },
];
